<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('webm-to-mp3-converter', 'WebM → MP3');

function handleBatchCreated(batchId: string) {
  console.log('[WebM-to-MP3 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[WebM-to-MP3 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[WebM-to-MP3 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[WebM-to-MP3 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[WebM-to-MP3 Converter] Credits updated:', credits);
}
</script>
